import { fetcher } from "helpers/fetcher";

import { PaginationReq } from "../types";
import { TGetProfileListRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getUserClientList = async (payload: PaginationReq) => {
  return await fetcher<TGetProfileListRes, PaginationReq>(
    ENDPOINT.USER.USER_CLIENT_LIST,
    {
      data: payload,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.USER_CLIENT_LIST.version,
      },
    }
  );
};

export const queryGetUserClientList = async (payload: PaginationReq) => {
  return (await getUserClientList(payload)).data;
};

queryGetUserClientList._key = (payload: PaginationReq) => [
  ENDPOINT.USER.USER_CLIENT_LIST.url,
  payload,
];
